import script from "./DailyFollowupCallsChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyFollowupCallsChart.vue?vue&type=script&setup=true&lang=js"

import "./DailyFollowupCallsChart.vue?vue&type=style&index=0&id=5252f195&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5252f195"]])

export default __exports__